import React, { useState, useEffect, Suspense, useMemo } from 'react';
import axios from 'axios';
import CoursesOnboardingCourseItem from './CoursesOnboardingCourseItem';

const CoursesOnboarding = () => {
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const [isLoadingCourse, setIsLoadingCourse] = useState(false);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get('/wp-json/draught/v1/learndash-courses');
        setCourses(response.data);
        console.log({ courses: response.data })
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching courses:', error);
        setError('Failed to load courses.');
        setIsLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const enrollCourse = async (courseId) => {
    try {
      const data = { courseId };

      setIsLoadingCourse(true);

      const response = await axios.post(`/wp-json/draught/v1/enroll-course`, data, { withCredentials: true });
      if (response.data.status === 'success') {
        window.location.href = response.data.first_lesson_url;
      }
    } catch (error) {
      // Let's just redirect to the course page if the user is already enrolled or if any error occurs
      const courseUrl = courses.find((course) => course.id === courseId).link;
      window.location.href = courseUrl;
    }
  };

  const [selectedCourse, setSelectedCourse] = useState(null);





  return (
    <Suspense fallback={<div>Loading courses...</div>}>
      <div className="text-center mb-4">
        <h3 className='text-black'>Welcome to C&C Bar Academy Online!</h3>
        <p>To get started, enroll in one of our courses and start your learning journey with us instantly:</p>
      </div>

      <div className='flex align-top gap-4'>
        <div className="flex-1 py-4">
          <h3 className='text-black mb-4'>Our Courses</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 h lg:grid-cols-4 gap-4 w-[800px] max-w-full">
            {isLoading &&
              <>
                <div className={`animate-skeleton bg-gray-200 h-[100px] w-full rounded-md`} />
                <div className={`animate-skeleton bg-gray-200 h-[100px] w-full rounded-md`} style={{ "--delay": "0.2s" }} />
                <div className={`animate-skeleton bg-gray-200 h-[100px] w-full rounded-md`} style={{ "--delay": "0.4s" }} />
                <div className={`animate-skeleton bg-gray-200 h-[100px] w-full rounded-md`} style={{ "--delay": "0.6s" }} />
                <div className={`animate-skeleton bg-gray-200 h-[100px] w-full rounded-md`} style={{ "--delay": "0.8s" }} />
                <div className={`animate-skeleton bg-gray-200 h-[100px] w-full rounded-md`} style={{ "--delay": "1s" }} />
              </>
            }

            {courses
              .filter(x => x.acf && x.acf.priority_course)
              .map((course) => (
                <CoursesOnboardingCourseItem
                  course={course}
                  isLoadingCourse={isLoadingCourse}
                  setSelectedCourse={setSelectedCourse}
                  key={course.id} />
              ))}
            {courses
              .filter(x => x.acf && !x.acf.priority_course)
              .map((course) => (
                <CoursesOnboardingCourseItem
                  course={course}
                  isLoadingCourse={isLoadingCourse}
                  setSelectedCourse={setSelectedCourse}
                  key={course.id} />
              ))}
          </div>


        </div>

        {selectedCourse && (
          <div className="course-description flex-1">
            <h3 className='text-black mb-4'>
              {selectedCourse.title.rendered}
            </h3>
            <div dangerouslySetInnerHTML={{ __html: selectedCourse.content.rendered }} />
            <button className='p-2 bg-red-500 text-white w-full rounded-md' onClick={() => enrollCourse(selectedCourse.id)}>
              {isLoadingCourse ? 'Enrolling...' : 'Enroll in this course'}
            </button>
          </div>
        )}

      </div>

    </Suspense>
  );
};

export default CoursesOnboarding;
